<div *ngIf="formGroup">
  <form style="padding-bottom: 2em" [formGroup]="formGroup" formFocusable>
    <mat-vertical-stepper [linear]="true" #stepper>
      <!-- Step -->
      <mat-step
        [hasError]="errorFormList | gridRegistrationErrorStepsPipe : errorStepsEnum.GisData"
        errorMessage="Bitte beheben Sie die Fehler">
        <ng-template matStepLabel>Anschlussobjekt</ng-template>
        <section>
          <app-select-gis-data
            [areaType]="areaTypePower"
            [inputForm]="formGroup"
            [inputFormAdditionalInfo]="formGroup.get('additionalInfoConnectionObject')"
            [isLoaded]="true"
            [listDevelopmentAreas]="listDevelopmentAreas"
            [showGetGisData]="true"
            [selectedGisData]="selectedGisData"
            [selectedCompanyLocation]="selectedCompanyLocation"
            [companyLocationsBytenant]="companyLocationsBytenant"
            [eventsFromParent]="eventsToGis"
            [errorFormList]="errorFormList"
            [state]="gridRegistrationState.Incomplete"
            (onSelectedGisData)="changeGisData($event)"></app-select-gis-data>
        </section>
        <app-show-errors
          *ngIf="errorStepFormList?.length > 0"
          [errorFormList]="
            errorStepFormList | gridRegistrationErrorListStepsPipe : errorStepsEnum.GisData
          "></app-show-errors>
        <div>
          <button mat-button (click)="goForward(errorStepsEnum.GisData)">Weiter</button>
        </div>
      </mat-step>

      <!-- Step -->
      <mat-step
        [hasError]="errorFormList | gridRegistrationErrorStepsPipe : errorStepsEnum.Filiation"
        errorMessage="Bitte beheben Sie die Fehler">
        <ng-template matStepLabel>Anlagenbetreiber</ng-template>
        <section>
          <app-filiation-form
            [inputFormArray]="formGroup.controls['filiationData']"
            [id]="null"
            [selectedGisData]="selectedGisData"
            [disableContractPartner]="true"></app-filiation-form>
          <div>
            <button mat-button (click)="goForward(errorStepsEnum.Filiation)">Weiter</button>
          </div>
        </section>
      </mat-step>

      <!-- Step -->
      <mat-step
        [hasError]="errorFormList | gridRegistrationErrorStepsPipe : errorStepsEnum.GridRegistrationType"
        *ngIf="gridRegistrationType == gridRegistrationTypeEnum.Feeder">
        <ng-template matStepLabel>Art der Erzeugungsanlage</ng-template>
        <section>
          <app-grid-registration-type
            *ngIf="gridRegistrationType == gridRegistrationTypeEnum.Feeder"
            [inputForm]="formGroup"
            (selectedPVModule)="selectedPVModule($event)"></app-grid-registration-type>
          <app-show-errors
            [errorFormList]="
              errorStepFormList | gridRegistrationErrorListStepsPipe : errorStepsEnum.GridRegistrationType
            "></app-show-errors>
          <div>
            <button mat-button (click)="goForward(errorStepsEnum.GridRegistrationType)">Weiter</button>
          </div>
        </section>
      </mat-step>

      <!-- Step  -->
      <mat-step
        [hasError]="errorFormList | gridRegistrationErrorStepsPipe : errorStepsEnum.MeterConcept"
        *ngIf="gridRegistrationType == gridRegistrationTypeEnum.Feeder">
        <ng-template matStepLabel>Messkonzept</ng-template>
        <section>
          <app-display-and-select-option
            [columns]="3"
            [article]="'ein'"
            [title]="'Messkonzept'"
            [disable]="disable"
            [options]="meteringListToShow"
            [selectedOption]="selectedMeteringConceptToShow"
            [canUpdate]="true"
            (onSelectedOptionChanged)="selectedGridRegistrationType($event)"></app-display-and-select-option>
          <app-show-errors
            [errorFormList]="
              errorStepFormList | gridRegistrationErrorListStepsPipe : errorStepsEnum.MeterConcept
            "></app-show-errors>
          <div>
            <button mat-button (click)="goForward(errorStepsEnum.MeterConcept)">Weiter</button>
          </div>
        </section>
      </mat-step>

      <!-- Step Erzeugungsanlagen -->
      <mat-step
        [hasError]="errorFormList | gridRegistrationErrorStepsPipe : errorStepsEnum.Producer"
        *ngIf="
          gridRegistrationType == gridRegistrationTypeEnum.Feeder ||
          gridRegistrationType == gridRegistrationTypeEnum.PlugInProducer
        ">
        <ng-template matStepLabel>Erzeugungseinheiten</ng-template>
        <section>
          <app-hint-card
            *ngIf="
              gridRegistrationType == gridRegistrationTypeEnum.PlugInProducer &&
              ('gridRegistration.PlugInProducer.producerSectionHint' | uiAdaptionVisible$ | async)
            "
            [type]="'info'"
            [outlined]="true"
            [constrainToPage]="true">
            <div
              [innerHTML]="
                'gridRegistration.PlugInProducer.producerSectionHint' | uiAdaptionValue | safeHtmlPipe
              "></div>
          </app-hint-card>
          <app-grid-registration-producer
            *ngIf="
              gridRegistrationType == gridRegistrationTypeEnum.Feeder ||
              gridRegistrationType == gridRegistrationTypeEnum.PlugInProducer
            "
            (inverterChanges)="producerChangesDetection()"
            [inputForm]="formGroup"
            [gridRegistrationType]="gridRegistrationType"
            [error]="
              !hasPvModule &&
              totalPowerProducers >= dataShareService.tenantConfig.gridRegistration.vde4105UpperLimit
            "
            [hasPVModule]="hasPvModule"
            [inputFormArray]="formGroup.controls['producers']"
            (totalPowerChanges)="totalPowerChanges($event)"
            [disable]="false"></app-grid-registration-producer>
          <app-show-errors
            style="float: left; width: 100%"
            [errorFormList]="
              errorStepFormList | gridRegistrationErrorListStepsPipe : errorStepsEnum.Producer
            "></app-show-errors>
          <div>
            <button mat-button (click)="goForward(errorStepsEnum.Producer)">Weiter</button>
          </div>
        </section>
      </mat-step>

      <!-- Step  -->
      <mat-step
        [hasError]="errorFormList | gridRegistrationErrorStepsPipe : errorStepsEnum.Consumer"
        *ngIf="
          gridRegistrationType == gridRegistrationTypeEnum.Charger ||
          gridRegistrationType == gridRegistrationTypeEnum.EHeating ||
          gridRegistrationType == gridRegistrationTypeEnum.Misc
        ">
        <ng-template matStepLabel>Verbraucher</ng-template>
        <section>
          <app-grid-registration-consumer
            *ngIf="
              gridRegistrationType == gridRegistrationTypeEnum.Charger ||
              gridRegistrationType == gridRegistrationTypeEnum.EHeating ||
              gridRegistrationType == gridRegistrationTypeEnum.Misc
            "
            (inverterChanges)="consumerChangesDetection()"
            [gridRegistrationType]="gridRegistrationType"
            [inputFormArray]="formGroup.controls['consumers']"
            [disable]="false"></app-grid-registration-consumer>
          <div>
            <button mat-button (click)="goForward(errorStepsEnum.Consumer)">Weiter</button>
          </div>
        </section>
      </mat-step>

      <!-- Step  -->
      <mat-step
        [hasError]="errorFormList | gridRegistrationErrorStepsPipe : errorStepsEnum.PVModule"
        *ngIf="
          (gridRegistrationType == gridRegistrationTypeEnum.Feeder &&
            formGroup.get('powerGenerationSource').value == feederTypeEnum.PhotoVoltaic) ||
          gridRegistrationType == gridRegistrationTypeEnum.PlugInProducer
        ">
        <ng-template matStepLabel>PV-Module</ng-template>
        <section>
          <app-grid-registration-pv-module
            *ngIf="
              (gridRegistrationType == gridRegistrationTypeEnum.Feeder &&
                formGroup.get('powerGenerationSource').value == feederTypeEnum.PhotoVoltaic) ||
              gridRegistrationType == gridRegistrationTypeEnum.PlugInProducer
            "
            [listInverterDevices]="listInverterDevices"
            [gridRegistrationType]="gridRegistrationType"
            [disable]="disable"
            (totalPVPowerChanges)="totalPowerPVModulesChanges($event)"
            [inputFormArray]="formGroup.controls['pvModules']"></app-grid-registration-pv-module>
          <app-show-errors
            style="float: left; width: 100%"
            [errorFormList]="
              errorStepFormList | gridRegistrationErrorListStepsPipe : errorStepsEnum.PVModule
            "></app-show-errors>
          <div>
            <button mat-button (click)="goForward(errorStepsEnum.PVModule)">Weiter</button>
          </div>
        </section>
      </mat-step>

      <mat-step
        [hasError]="errorFormList | gridRegistrationErrorStepsPipe : errorStepsEnum.FeedinManagementInfo"
        *ngIf="
          selectedCompanyLocation &&
          gridRegistrationType == gridRegistrationTypeEnum.Feeder &&
          ((totalPowerPVModules > 0 &&
            totalPowerPVModules < dataShareService.tenantConfig.gridRegistration.vde4105UpperLimit &&
            hasPvModule) ||
            (totalPowerProducers > 0 &&
              totalPowerProducers < dataShareService.tenantConfig.gridRegistration.vde4105UpperLimit &&
              !hasPvModule))
        ">
        <ng-template matStepLabel>Einspeisermanagement</ng-template>
        <section>
          <app-grid-registration-feedin-management-info
            *ngIf="selectedCompanyLocation"
            [error]="errorFormList.length > 0 && !formGroup.get('feedInManagementInfo').value"
            [hasPvModule]="hasPvModule"
            [selectedCompanyLocation]="selectedCompanyLocation"
            [inputForm]="formGroup"
            [totalPowerProducers]="
              hasPvModule ? totalPowerPVModules : totalPowerProducers
            "></app-grid-registration-feedin-management-info>
          <app-show-errors
            style="float: left"
            [errorFormList]="
              errorStepFormList | gridRegistrationErrorListStepsPipe : errorStepsEnum.FeedinManagementInfo
            "></app-show-errors>
          <div>
            <button mat-button (click)="goForward(errorStepsEnum.FeedinManagementInfo)">Weiter</button>
          </div>
        </section>
      </mat-step>

      <!-- Step  -->
      <mat-step
        [hasError]="errorFormList | gridRegistrationErrorStepsPipe : errorStepsEnum.Storage"
        *ngIf="gridRegistrationType == gridRegistrationTypeEnum.Feeder">
        <ng-template matStepLabel>Speicher</ng-template>
        <section>
          <app-grid-registration-storage
            *ngIf="gridRegistrationType == gridRegistrationTypeEnum.Feeder"
            [selectedStorageConceptToShow]="selectedStorageConceptToShow"
            [storageListToShow]="storageListToShow"
            [hasStorageControl]="formGroup"
            [cardFormat]="false"
            [storagesFormArray]="formGroup.controls['storages']"
            [canUpdate]="true"
            (isHasStorage)="isHasStorage($event)"
            (isSelectedOption)="isSelectedStorageConcept($event)"></app-grid-registration-storage>
          <app-show-errors
            [errorFormList]="
              errorStepFormList | gridRegistrationErrorListStepsPipe : errorStepsEnum.Storage
            "></app-show-errors>
          <div>
            <button mat-button (click)="goForward(errorStepsEnum.Storage)">Weiter</button>
          </div>
        </section>
      </mat-step>

      <!-- Step  -->
      <mat-step [hasError]="errorFormList | gridRegistrationErrorStepsPipe : errorStepsEnum.MoreInfo">
        <ng-template matStepLabel>Weitere Informationen zum Netzanschluss</ng-template>
        <section>
          <div class="wrapper" *ngIf="gridRegistrationType == gridRegistrationTypeEnum.PlugInProducer">
            <div class="col" fxFlex="100">
              <mat-form-field appearance="outline" fxFlex="95">
                <mat-label>Zählernummer</mat-label>
                <input matInput type="text" maxlength="90" formControlName="meterNumber" />
              </mat-form-field>
            </div>
          </div>

          <form-row
            *ngIf="
              gridRegistrationType == gridRegistrationTypeEnum.PlugInProducer &&
              ('gridRegistration.PlugInProducer.conditionsCheckbox' | uiAdaptionVisible$ | async)
            ">
            <mat-checkbox [formControl]="customConditionsCheckbox">
              <div
                [innerHTML]="
                  'gridRegistration.PlugInProducer.conditionsCheckbox' | uiAdaptionValue | safeHtmlPipe
                "></div>
            </mat-checkbox>
          </form-row>
          <mat-error *ngIf="customConditionsCheckbox.touched && customConditionsCheckbox.invalid">
            Bitte akzeptieren Sie alle Bedingungen
          </mat-error>

          <app-grid-registration-more-info
            *ngIf="gridRegistrationType != gridRegistrationTypeEnum.PlugInProducer"
            [inputForm]="formGroup"
            [gridRegistrationType]="gridRegistrationType"
            [inputFormFreeMoreInformation]="formGroup"
            (hasInstalledDevices)="hasInstalledDevices($event)"></app-grid-registration-more-info>

          <app-upload-documents
            *ngIf="gridRegistrationType != gridRegistrationTypeEnum.PlugInProducer"
            [inputFormArray]="formGroup.controls['uploads']"
            [showTag]="false"
            [documentTag]="documentTagEnum.gridRegistrationDoc"
            [filterCriteria]="compareEnum.equal"
            [numberOfUploads]="3"
            [editUpload]="true"
            [showUploadButton]="true"
            [canUpdate]="true">
            <p>
              Bitte laden Sie uns hier die relevanten technischen Dokumentationen hoch.
              <br />
              z.B. Datenblätter der verbauten Komponenten, Zertifikate und einen einpoligen
              Übersichtsschaltplan.
              <br />
              Ggf. einen Nachweis Eigenverbrauch < 30.000kWh.
            </p>
          </app-upload-documents>

          <div>
            <button mat-button (click)="goForward(errorStepsEnum.MoreInfo)">Weiter</button>
          </div>
        </section>
      </mat-step>

      <!-- Step  -->
      <mat-step>
        <ng-template matStepLabel>
          <p (click)="loadDataFromForm()">Zusammenfassung</p>
        </ng-template>
        <section>
          <app-connection-object-summary
            [connectionObject]="gridRegistration?.connectionObject"
            [connectionObjectAdditionalInfo]="
              gridRegistration?.connectionObjectAdditionalInfo
            "></app-connection-object-summary>
        </section>

        <section>
          <app-filiation-data-summary
            [contactData]="gridRegistration?.customer"
            [title]="'Vertragspartner'"></app-filiation-data-summary>
        </section>

        <section *ngIf="gridRegistration?.invoiceContact">
          <app-filiation-data-summary
            [contactData]="gridRegistration?.invoiceContact"
            [title]="'Abweichende Rechnungsanschrift'"></app-filiation-data-summary>
        </section>

        <section *ngIf="gridRegistration?.producers && gridRegistration?.producers.length > 0">
          <app-producers-summary
            [showOnlyTotal]="gridRegistrationType == gridRegistrationTypeEnum.PlugInProducer"
            [producers]="gridRegistration.producers"
            [consumptionOver30kw]="gridRegistration.consumptionOver30kw"></app-producers-summary>
        </section>

        <section *ngIf="gridRegistration?.consumers && gridRegistration?.consumers.length > 0">
          <app-consumers-summary [consumers]="gridRegistration.consumers"></app-consumers-summary>
        </section>

        <section *ngIf="gridRegistration?.storages && gridRegistration?.storages.length > 0">
          <app-storages-summary [storages]="gridRegistration.storages"></app-storages-summary>
        </section>

        <section *ngIf="gridRegistration?.pvModules && gridRegistration?.pvModules.length > 0">
          <app-pv-modules-summary
            [showOnlyTotal]="gridRegistrationType == gridRegistrationTypeEnum.PlugInProducer"
            [pvModules]="gridRegistration.pvModules"></app-pv-modules-summary>
        </section>

        <!-- -->
        <div *ngIf="gridRegistrationType === gridRegistrationTypeEnum.PlugInProducer">
          Der Anlagenbetreiber bestätigt:
          <ul>
            <li>Die Richtigkeit der oben genannten Angaben.</li>
            <li>
              Die Erzeugungsanlage entspricht den allgemein anerkannten Regeln der Technik, insbesondere der
              VDE-AR-N 4105.
            </li>
          </ul>

          <p>
            Der erzeugte Strom wird selbst verbraucht. Für eventuell in das Netz eingespeisten Strom wird
            keine Vergütung gemäß der Fördergesetze (EEG, KWKG) beansprucht.
          </p>

          <h3>Vergütung</h3>

          Sollten Sie für den eingespeisten Strom die gesetzliche Vergütung wünschen, beachten Sie bitte
          folgendes:

          <p>Eine Vergütung ist nur möglich, wenn die Anlage folgendes erfüllt:</p>
          <ul>
            <li>Die Anlage hat einen Vergütungsanspruch nach dem EEG.</li>
            <li>
              Die Anlage ist an dem für den dauerhaften Betrieb vorgesehenen Ort auf, an oder in einem Gebäude
              und dauerhaft mit dem für die Erzeugung von Wechselstrom erforderlichen Zubehör installiert.
            </li>
          </ul>

          und die nachfolgenden Unterlagen vorliegen:
          <ul>
            <li>Registrierungsbestätigung der Anlage im Marktstammdatenregister.</li>
            <li>Angaben zur Bankverbindung - Angaben zur Ausweisung „Umsatzsteuer“</li>
          </ul>

          <p>Sollten Sie eine Vergütung wünschen, wenden Sie sich bitte an {{ eegCompensationContact }}.</p>

          <h3>Ergänzende Hinweise:</h3>

          <ul>
            <li>
              Weitere Meldepflichten ergeben sich aus dem Erneuerbare-Energien-Gesetz (EEG) bzw. der
              Marktstammdatenregisterverordnung (MaStRV). Weitere Informationen hierzu stellt die
              Bundesnetzagentur zur Verfügung.
            </li>

            <li>
              Der VDE|FNN hat eine Zusammenstellung von häufig gestellten Fragen zu steckerfertigen PV-Anlagen
              unter
              <a
                target="_blank"
                href="www.vde.com/de/fnn/themen/tar/tar-niederspannung/erzeugungsanlagen-steckdose">
                www.vde.com/de/fnn/themen/tar/tar-niederspannung/erzeugungsanlagen-steckdose
              </a>
              veröffentlicht
            </li>
          </ul>
        </div>

        <app-accept-conditions
          [inputForm]="formGroup.controls['acceptConditions']"
          [controlName]="'ownerConsent'"
          [disable]="false"
          [inputLink]=""
          [inputText]="
            'Hiermit bestätige ich, dass die Zustimmung des Eigentümers vorliegt.'
          "></app-accept-conditions>

        <app-form-confirmation
          [actions]="actions"
          [actionConfirm]="'createExternalGridRegistration'"
          [textConfirm]="gridRegistration.id != null ? 'Gerätedaten ändern' : 'Gerät anmelden'"
          [actionReject]="null"
          [message]="
            gridRegistration.id != null
              ? 'Sind Sie sicher, dass Sie die Gerätedaten ändern möchten?'
              : 'Sind Sie sicher, dass Sie das Gerät anmelden möchten?'
          "
          [errorFormList]="errorFormList"
          (onActionClickedEvent)="registerDevice($event)"></app-form-confirmation>
      </mat-step>
    </mat-vertical-stepper>
  </form>
</div>
